import config from "./config.js";
const valenHrModuleDisplayName = config.modules.valenHr.displayName;
const valenHrModuleRoutePath = config.modules.valenHr.routePath;

const routes = [

	//---- Module: "Tessta Clients" (Tessta Client Portal)
	{
		path: "/module/" + valenHrModuleRoutePath,
		name: "valen-hr-index",
		component: () => import("./module.valen-hr/index.vue"),
		meta: { layout: "primary2", module: "valenHr", pageTitle: valenHrModuleDisplayName }
	},

	{
		path: "/module/" + valenHrModuleRoutePath + "/admin",
		name: "valen-hr-admin-index",
		component: () => import("./module.valen-hr/admin/index.vue"),
		meta: {
			layout: "primary2",
			module: "valenHr",
			pageTitle: valenHrModuleDisplayName + " > Admin"
		},
		props: true
	},

	{
		path: "/module/" + valenHrModuleRoutePath + "/employee",
		name: "valen-hr-employee-index",
		props: true,
		component: () => import("./module.valen-hr/employee/index.vue"),
		meta: {
			layout: "primary2",
			module: "valenHr",
			//pageTitle: valenHrModuleDisplayName + " > Employee Dashboard"
			pageTitle: valenHrModuleDisplayName + " > My Dashboard"
		}
	},

	{
		path: "/module/" + valenHrModuleRoutePath + "/manager",
		name: "valen-hr-manager",
		component: () => import("./module.valen-hr/manager/index.vue"),
		meta: {
			layout: "primary2",
			module: "valenHr",
			pageTitle: valenHrModuleDisplayName + " > Manager Dashboard"
		},
		props: true,
		children: [
			{
				name: "valen-hr-manager-index-redirect",
				path: "",
				redirect: { name: "valen-hr-manager-index" }
			},
			{
				path: "dashboard",
				name: "valen-hr-manager-index",
				meta: {
					layout: "primary2",
					module: "valenHr",
					pageTitle: valenHrModuleDisplayName + " > Manager Dashboard"
				},
				props: true,
				component: () => import("./module.valen-hr/manager/pages/Dashboard.vue")
			},
			{
				path: "performance-reviews",
				name: "valen-hr-manager-performance-reviews",
				meta: {
					layout: "primary2",
					module: "valenHr",
					pageTitle: valenHrModuleDisplayName + " > Performance Reviews"
				},
				props: true,
				component: import("./module.valen-hr/manager/pages/PerformanceReviews.vue")
			}
		]
	},

	{
		path: "/module/" + valenHrModuleRoutePath + "/kudos",
		name: "valen-hr-kudos",
		component: () => import("./module.valen-hr/kudos/index.vue"),
		meta: {
			layout: "primary2",
			module: "valenHr",
			pageTitle: valenHrModuleDisplayName + " > Kudos"
		},
		props: true,
		children: [
			{
				name: "valen-hr-kudos-index-redirect",
				path: "",
				redirect: { name: "valen-hr-kudos-index" }
			},
			{
				path: "dashboard",
				name: "valen-hr-kudos-index",
				meta: {
					layout: "primary2",
					module: "valenHr",
					pageTitle: valenHrModuleDisplayName + " > Kudos"
				},
				props: true,
				component: () => import("./module.valen-hr/kudos/pages/Dashboard.vue")
			},
			{
				// 👇 include :staffId as a dynamic segment
				path: "user/:staffId",
				name: "valen-hr-kudos-user",
				meta: {
					layout: "primary2",
					module: "valenHr",
					pageTitle: valenHrModuleDisplayName + " > Give Kudos"
				},
				props: true,
				component: () => import("./module.valen-hr/kudos/pages/UserKudos.vue")
			}
		]
	},

	//TODO: Obsolete. Use the 2 sub-routes insetad because we need to pass in param values.
	{
		path: "/module/" + valenHrModuleRoutePath + "/review",
		name: "valen-hr-review-index",
		component: () => import("./module.valen-hr/review/ReviewList.vue"),
		meta: {
			layout: "primary2",
			module: "valenHr",
			pageTitle: valenHrModuleDisplayName + " > New Employee Review"
		},
		props: true
	},

	{
		path: "/module/" + valenHrModuleRoutePath + "/review/new/:staffId/:reviewId",
		name: "valen-hr-review-new",
		component: () => import("./module.valen-hr/review/ReviewPage.vue"),
		meta: {
			layout: "primary2",
			module: "valenHr",
			pageTitle: valenHrModuleDisplayName + " > New Employee Review"
		},
		props: true
	},
	{
		path: "/module/" + valenHrModuleRoutePath + "/review/edit/:staffId/:reviewId",
		name: "valen-hr-review-edit",
		component: () => import("./module.valen-hr/review/ReviewPage.vue"),
		meta: {
			layout: "primary2",
			module: "valenHr",
			pageTitle: valenHrModuleDisplayName + " > Edit Employee Review"
		},
		props: true
	},

	//TODO: This route is obsolete. See route with :staffId
	{
		path: "/module/" + valenHrModuleRoutePath + "/user-profile",
		name: "valen-hr-user-profile-index",
		component: () => import("./module.valen-hr/user-profile/index.vue"),
		meta: {
			layout: "primary2",
			module: "valenHr",
			pageTitle: valenHrModuleDisplayName + " > User Profile"
		},
		props: true
	},
	{
		path: "/module/" + valenHrModuleRoutePath + "/user-profile/:staffId",
		name: "valen-hr-user-profile",
		component: () => import("./module.valen-hr/user-profile/index.vue"),
		meta: {
			layout: "primary2",
			module: "valenHr",
			pageTitle: valenHrModuleDisplayName + " > User Profile"
		},
		props: true
	},
		// Printable version
		{
			path: "/module/" + valenHrModuleRoutePath + "/user-profile/:staffId/print",
			name: "valen-hr-user-profile-print",
			component: () => import("./module.valen-hr/user-profile/index.vue"),
			meta: {
				layout: "no",
				module: "valenHr",
				pageTitle: valenHrModuleDisplayName + " > User Profile"
			},
			props: true
		}
];

export default routes;
